import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useTracking } from '@broadleaf/admin-components/dist/tracking';
import { ContextParameters } from '@broadleaf/admin-components/dist/tracking/utils/ContextRequest';
import { IMetadata } from '@broadleaf/admin-components/dist/types/metadata';
import {
  IFulfillmentContextParams,
  IOrderFulfillment
} from '@broadleaf/admin-components/dist/types/oms';

export default function useContextParams(
  metadata: IMetadata,
  fulfillment: IOrderFulfillment = undefined
): IFulfillmentContextParams {
  const { id } = useParams() as Record<string, any>;
  const tracking = useTracking(metadata);
  return useMemo(() => {
    const contextParams = {} as IFulfillmentContextParams;
    if (id) {
      contextParams.id = id;
    }

    if (tracking) {
      contextParams[ContextParameters.TRACKING] = tracking;
    }

    if (fulfillment) {
      contextParams.parent = contextParams.fulfillment = fulfillment;
      contextParams.fulfillmentId = fulfillment.id;
      contextParams.orderId = fulfillment.orderId;
    }

    return contextParams;
  }, [id, fulfillment, tracking]);
}
